<div class="footer">
  <div class="links-container column-1-1">
    <!-- Enlaces con Imágenes -->
    <div class="image-links-container">
      <ng-container *ngIf="imgLinks">
        <div *ngFor="let imglink of imgLinks">
          <img class="image-links" *ngIf="imglink" [src]="getSafeImageUrl(imglink)"
            [alt]="imglink.fields?.title || 'Imagen decorativa'" [attr.width]="imglink.fields?.imageWidth"
            [attr.height]="imglink.fields?.imageHeight" (click)="openSecureWindow(imglink, true)">
        </div>
      </ng-container>
    </div>
    <!-- Enlaces de Texto -->
    <div class="text-links-container">
      <ng-container *ngIf="textLinks">
        <div class="text-links" *ngFor="let textLink of textLinks">
          <a [href]="textLink.fields.linkUrl" [id]="textLink.fields.customElementId" target="_blank">
            {{ textLink?.fields?.textLabel }}
          </a>
        </div>

      </ng-container>
      <br>
    </div>
  </div>
  <!-- Texto Legal y Copyright -->
  <!-- <p class="legal-text">{{ footerContent?.fields?.legalText | safeString | mdToHtml }}</p> -->
  <div id="footerdisclaimer" class="footer-disclaimer" [innerHTML]="footerContent?.fields?.legalText | safeString | mdToHtml"></div>
  <!-- <div [innerHTML]="footerContent?.fields?.legalText | richText"></div> -->

  
  <p class="copyright" *ngIf="footerContent?.fields?.copyright">{{ footerContent?.fields?.copyright }}</p>
</div>